import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Type extends Component {
  static propTypes = {
    applyFilter: PropTypes.func,
    onChange: PropTypes.func,
    types: PropTypes.arrayOf(PropTypes.string).isRequired,
    typeCounts: PropTypes.shape({
      apartment: PropTypes.number,
      hotel: PropTypes.number,
      villa: PropTypes.number,
    }).isRequired,
  }

  state = {
    types: [],
  }

  constructor (props) {
    super(props)

    this.state = {
      types: props.types,
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      types: nextProps.types,
    })
  }

  applyFilter = () => {
    this.props.applyFilter({
      types: this.state.types,
    })
  }

  handleChange = (value) => {
    if (this.props.onChange) {
      this.props.onChange(value)
    } else {
      this.setState((state) => ({
        types: state.types.includes(value)
          ? state.types.filter((item) => item !== value)
          : [ ...state.types, value ],
      }))
    }
  }

  toggleTypeFactory = (value) => () => this.handleChange(value)

  render () {
    const { typeCounts, applyFilter } = this.props
    const { types } = this.state

    return (
      <>
        <div className='form__group'>
          <label className='form__label'>Type</label>
          <div className='form__control'>
            <ul className='option-list option-list--type'>
              <li>
                <input
                  className='checkbox-item form__checkbox'
                  type='checkbox'
                  name='transport'
                  id='apartment'
                  checked={types.includes('apartment')}
                  onChange={this.toggleTypeFactory('apartment')}
                />
                <label htmlFor='apartment'>
                  Apartment
                  <span className='badge badge--search-filter'>{typeCounts.apartment}</span>
                </label>
              </li>
              <li>
                <input
                  className='checkbox-item form__checkbox'
                  type='checkbox'
                  name='transport'
                  id='hotel'
                  checked={types.includes('hotel')}
                  onChange={this.toggleTypeFactory('hotel')}
                />
                <label htmlFor='hotel'>
                  Hotel
                  <span className='badge badge--search-filter'>{typeCounts.hotel}</span>
                </label>
              </li>
              <li>
                <input
                  className='checkbox-item form__checkbox'
                  type='checkbox'
                  name='transport'
                  id='villa'
                  checked={types.includes('villa')}
                  onChange={this.toggleTypeFactory('villa')}
                />
                <label htmlFor='villa'>
                  Villa
                  <span className='badge badge--search-filter'>{typeCounts.villa}</span>
                </label>
              </li>
            </ul>
          </div>
        </div>

        {applyFilter && <button type='button' className='btn btn--primary filter-button' onClick={this.applyFilter}>Apply filters</button>}
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/filters/Type.js